import React from 'react';
import PropTypes from 'prop-types';
import {TableItalicColumnStyle} from './Table.styled';

export const ItalicElement = React.memo(function TableColumn({children}) {
	return <TableItalicColumnStyle tabIndex={'0'}>{children}</TableItalicColumnStyle>;
});

ItalicElement.propTypes = {
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
